import React, { useState } from "react";
import useGlobal from "../../../store";
import Button from "../button";
import ToggleSlider from "../toggleslider";

const SmetaFoamCracks = ({ close }) => {

  const [ globalState, globalActions ] = useGlobal();
  const { foamCracks } = globalState;
  const { environment } = globalActions;
  
  const [ type, setType ] = useState( foamCracks.type );

  function handleAddFoamCracks() {
    
    environment.addEnvironmentToSmeta("foamCracks", { added: true, type } );
    close();

  }
  
  return (

    <div className="smeta__isolation p-14" draggable="false">

      <ToggleSlider

        title = "Толщина:"
        list = {[ "3м", "6м" ]}
        selected = { type }
        select = { setType }

      />

      <Button

        text = { !foamCracks.added ? "Добавить" : "Сохранить" }
        action = { handleAddFoamCracks }

      />

    </div>

  );

}

export default SmetaFoamCracks;